import { render, staticRenderFns } from "./org_squad_preview_statistics.vue?vue&type=template&id=0d33fbf4&scoped=true"
import script from "./org_squad_preview_statistics.vue?vue&type=script&lang=js"
export * from "./org_squad_preview_statistics.vue?vue&type=script&lang=js"
import style0 from "./org_squad_preview_statistics.vue?vue&type=style&index=0&id=0d33fbf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d33fbf4",
  null
  
)

export default component.exports